<app-base-modal
  title="Объединение блогеров"
>
  <p class="blogger-deduplication-title">Оригинал</p>
  <app-blogger-info
    [bloggerData]="dialogData.currentBlogger"
    (handleOpenBloggerModal)="handleOpenBloggerModal(dialogData.currentBlogger)"
  />
  <div class="separator"></div>
  <p class="blogger-deduplication-title">Повторы</p>
  <mat-form-field
    class="search"
    appearance="outline"
  >
    <input
      #searchInput
      matInput
      placeholder="Поиск"
      [(ngModel)]="searchBloggerNameOrUrl"
      (blur)="loadBloggers()"
      (keyup.enter)="searchInput.blur()"
    >
    <mat-label>Поиск блогера</mat-label>
  </mat-form-field>
  @if (isLoading) {
    <app-loader/>
  }
  <div class="content">
    <mat-selection-list
      [multiple]="false"
      [(ngModel)]="selectedBloggers"
    >
      @for (blogger of bloggers; track $index) {
        <mat-list-option [value]="blogger">
          <app-blogger-info
            [bloggerData]="blogger"
            (handleOpenBloggerModal)="handleOpenBloggerModal(blogger)"
          />
        </mat-list-option>
      }
    </mat-selection-list>
    @if (!hasBloggers) {
      <div class="no-result">
        Нет дубликатов
      </div>
    }
  </div>
  <div class="buttons-container">
    @if (hasBloggers) {
      <button
        mat-button
        class="save-button"
        [disabled]="!selectedBloggers.length"
        (click)="onSelectBlogger()"
      >
        Объединить
      </button>
    }
    <button
      mat-button
      tabindex="-1"
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
